module.exports = __webpack_public_path__ + "static/img/3.4977a04.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/15/eng/3.png
// module id = +BQt
// module chunks = 0